import { useState } from "react";
import { cn } from "@/lib/cn";
import { initialsFromName } from "@/lib/media";

type AvatarProps = {
  name: string;
  src?: string | null;
  size?: "sm" | "md" | "lg";
  className?: string;
};

const sizes = {
  sm: "h-8 w-8 text-xs",
  md: "h-10 w-10 text-sm",
  lg: "h-12 w-12 text-base",
};

export function Avatar({ name, src, size = "md", className }: AvatarProps) {
  const [failed, setFailed] = useState(false);
  const showImage = Boolean(src) && !failed;

  return (
    <div
      aria-label={name}
      className={cn(
        "inline-flex items-center justify-center overflow-hidden rounded-full bg-primary/10 font-semibold text-primary",
        sizes[size],
        className,
      )}
    >
      {showImage ? (
        <img
          src={src!}
          alt={name}
          className="h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        initialsFromName(name)
      )}
    </div>
  );
}
